function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { addVoucher, removeVoucher, updateKlarna, updateAdyen } from "../../shop/connect";
import checkout from "../../routes/checkout";
import { reloadGECheckout } from "../../components/global-e";
var isCheckoutPage = function isCheckoutPage() {
  return $('body.checkout').length > 0;
};
var voucher = function voucher() {
  $(".js-checkoutPageVoucher").on("click", ".js-toggleVoucher", function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().find("form").removeClass("is-invalid").find(".u-input").removeClass("is-invalid");
    $(e.currentTarget).parent().toggleClass("is-toggled");
  });
  $(".js-checkoutPageVoucher").on("keydown change blur", "input,select", function (e) {
    $(e.currentTarget).closest(".u-checkbox").removeClass("is-invalid").end().parent().removeClass("is-invalid");
    $(e.currentTarget).removeClass("is-invalid").closest("form").removeClass("is-invalid");
  });
  $(".js-checkoutPageVoucher").on("submit", ".js-addVoucher", function (e) {
    e.preventDefault();
    console.log('submit voucher triggered');
    var $this = $(e.currentTarget);
    var formInputs = $this.serializeArray().reduce(function (acc, input) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, input.name, input.value));
    }, {});
    var button = $this.find("button[type='submit']");
    var formInput = $this.find("input");
    button.addClass("is-loading");
    addVoucher(formInputs.voucher).then(function (action) {
      if (action.type === "VOUCHER_ERROR" && !formInput.parent().hasClass('is-invalid')) {
        formInput.parent().addClass("is-invalid");
        formInput.parent().after("<div class=\"invalid-feedback\">".concat(window.sitewide.voucherError || 'Voucher not found', "</div>"));
        formInput.addClass("is-invalid");
      } else {
        $this[0].reset();
        if (isCheckoutPage()) {
          updateKlarna();
          updateAdyen();
        }
        reloadGECheckout();
      }
      button.removeClass("is-loading");
    }).catch(function () {
      formInput.parent().addClass("is-invalid");
      formInput.addClass("is-invalid");
      button.removeClass("is-loading");
    });
  });
  $(".js-checkoutPageVoucher").on("click", ".js-removeVoucher", function (e) {
    e.preventDefault();
    var $this = $(e.currentTarget);
    removeVoucher($this.data("voucher")).then(function () {
      if (isCheckoutPage()) {
        updateKlarna();
        updateAdyen();
        checkout.updateSelectionError();
      }
      reloadGECheckout();
    });
  });
};
export default voucher;


// WEBPACK FOOTER //
// ./scripts/partials/top/voucher.js